import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a3cc2ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "video-container" }, [
  /*#__PURE__*/_createElementVNode("video", { id: "video" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "ion-padding",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("expiredSession.title")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("expiredSession.description")), 1),
          (_ctx.qrScanner === null)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "primary-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openQrScanner && _ctx.openQrScanner(...args)))
              }, _toDisplayString(_ctx.$t("expiredSession.scanQr")), 1))
            : _createCommentVNode("", true),
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}